<style lang="scss">
  @import "@/assets/scss/vuexy/components/listItem.scss";
</style>
<template>
  <vs-td>
      <div class="device-info">
          <div class="shadow-drop d-theme-dark-bg cursor-pointer round">
            <img :src="getImgUrl(img)" class="info-icon p-2 block"/>
          </div>
          <div class="device-text-container" v-if="!relativeTime">
            <span class="main-info">{{value}}<span class="unit">{{unit}}</span></span>
            <span class="subtext-info">{{description}}</span>
          </div>
          <div class="device-text-container" v-if="relativeTime">
            <span class="main-info">{{relativeTimeConvert(value)}}</span>
          </div>
      </div>
  </vs-td>
</template>
<script>
export default {
  props:{
    img: String,
    value: String,
    unit: String,
    description: String,
    relativeTime: Boolean
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${  name  }.svg`)
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    }
  }
}
</script>